import {
  DotsThreeVerticalIcon,
  PasswordIcon,
  SignOutIcon,
  UserCircleIcon,
} from '@phosphor-icons/react';
import { Link } from '@tanstack/react-router';
import { ActionIcon, Avatar, Box, Group, Menu, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import ChangePassword from '@/modules/change-password/ChangePassword';
import { useGetUsersCurrent } from '@/services/users';
import { useAuthStore } from '@/stores';
import styles from './Navbar.module.css';

const NavbarBottom = () => {
  const { logout } = useAuthStore();

  const { data } = useGetUsersCurrent();

  const name = data?.data?.name ?? '-';
  const number = data?.data?.number ?? '-';
  const [opened, { close, open }] = useDisclosure(false);

  return (
    <Box p={16} className={styles.NavbarBottom} mt="auto">
      <Group gap={10}>
        <Avatar size={40}>JD</Avatar>
        <Stack gap={0}>
          <Text fw={600} fz={14}>
            {name}
          </Text>
          <Text fw={400} fz={12} c="gray">
            {number}
          </Text>
        </Stack>
        <Menu shadow="md" width={200} withinPortal position="bottom-end" zIndex={600}>
          <Menu.Target>
            <ActionIcon variant="subtle" ml="auto" color="dark">
              <DotsThreeVerticalIcon color="black" weight="bold" size={20} />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item leftSection={<UserCircleIcon size={16} />} component={Link} to="/profile">
              Detail Profile
            </Menu.Item>
            <Menu.Item leftSection={<PasswordIcon size={16} />} onClick={open}>
              Ubah Kata Sandi
            </Menu.Item>
            <Menu.Item leftSection={<SignOutIcon size={16} />} onClick={logout}>
              Keluar
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
      <ChangePassword opened={opened} onClose={close} />
    </Box>
  );
};

export default NavbarBottom;
